/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { EditIcon } from 'components/elements/Icons';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function FormButtons({ children, onReset, onModeUpdate, isEditMode }) {
  const classes = useStyles(Styles);
  const { t } = useTranslation('labels');

  return (
    <>
      <div className={classes.editableInfoWrapper}>{children}</div>
      <div className={classes.controlsWrapper}>
        {isEditMode ? (
          <>
            <Button
              data-testid="cancel-button"
              className={classes.editButton}
              variant="outlined"
              onClick={() => {
                onReset();
                onModeUpdate(false);
              }}
              color="primary"
            >
              {t('cancel')}
            </Button>
            <Button data-testid="save-button" className={classes.editButton} variant="contained" type="submit" color="primary">
              {t('save')}
            </Button>
          </>
        ) : (
          <Button data-testid="edit-button" className={classes.editButton} variant="contained" color="primary" onClick={() => onModeUpdate(true)}>
            <EditIcon classes={classes.editIcon} />
            {t('edit')}
          </Button>
        )}
      </div>
    </>
  );
}

FormButtons.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]).isRequired,
  onReset: PropTypes.func.isRequired,
  onModeUpdate: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool.isRequired,
};

export default FormButtons;
